/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_PAYMENT_ROUTE_CARTSERVICE = '/payment';
const RESOURCE_PAGE_ROUTE_CARTSERVICE = '/clienttoken';

/**
 * getPaymentCommonClientToken
 * url - /checkout/{apiversion}/payment/clienttoken?brand={brandId}&paymentMethod={paymentMethod}
 *
 * @param {Object} args
 * @param {Object} args.env
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 * @param {String} args.paymentmethod
 */
const getPaymentCommonClientToken = ({
    env, jwtToken, paymentMethod,
}) => {
    const envObj = env || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    let paymentParam = '';

    paymentParam = `?paymentMethod=${paymentMethod}`;

    const resourcePage =  `${RESOURCE_PAGE_CARTSERVICE}${RESOURCE_PAGE_PAYMENT_ROUTE_CARTSERVICE}${RESOURCE_PAGE_ROUTE_CARTSERVICE}${paymentParam}`;

    return restClient.getRequest(envObj, resourcePage, jwtToken)
        .then((response) => response);
};

export default getPaymentCommonClientToken;
